import { render, staticRenderFns } from "./ViolationControl.vue?vue&type=template&id=68523ff0&scoped=true&"
import script from "./ViolationControl.vue?vue&type=script&lang=js&"
export * from "./ViolationControl.vue?vue&type=script&lang=js&"
import style0 from "./ViolationControl.vue?vue&type=style&index=0&id=68523ff0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68523ff0",
  null
  
)

export default component.exports